module.exports = __webpack_public_path__ + "img/bg.46251b21.png";